import { Check } from 'lucide-react';
import '@/components/companion/companion.css';

/** 一列文字加右側開關；小哨面板、通知設定與 AI 設定共用同一種樣式。 */
export function SettingSwitch({ label, description, checked, disabled, onChange }: {
  label: string;
  description?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) {
  return <label className={`companion-setting${disabled ? ' cursor-not-allowed opacity-60' : ''}`}>
    <span className="min-w-0 flex-1">
      <span className="block text-[13px] font-medium">{label}</span>
      {description && <span className="mt-1 block text-[11px] leading-relaxed text-muted-foreground">{description}</span>}
    </span>
    <input type="checkbox" className="companion-switch-input" checked={checked} disabled={disabled}
      onChange={(event) => onChange(event.target.checked)} />
    <span aria-hidden="true" className="companion-switch"><span><Check size={11} /></span></span>
  </label>;
}
